<template>
  <div>
    <!-- Tabs Navigation -->
    <b-tabs
      v-model="activeTab"
      content-class="mt-1"
    >
      <!-- Tab 1: Template Normal -->
      <b-tab
        title="Template Padrão"
        active
      >
        <b-row>
          <b-col
            cols="12"
            class="mt-1"
          >
            Título :
            <b-form-input
              v-model="template.titulo"
              placeholder="Título"
            />
          </b-col>

          <!-- Conditional Dialog ID Input -->
          <b-col
            v-if="showDialogIdInput"
            cols="12"
            class="mt-1"
          >
            Dialog ID:
            <b-form-input
              v-model="template.dialogo_id"
              placeholder="Dialog ID"
              type="text"
            />
          </b-col>

          <b-col
            cols="12"
            class="mt-1"
          >
            Mensagem :
            <b-form-textarea
              v-model="template.mensagem"
              placeholder="Mensagem"
              rows="4"
              max-rows="8"
            />
          </b-col>
          <b-col
            cols="12"
            class="mt-1 d-flex align-items-center"
          >
            Status:
            <b-form-checkbox
              v-model="template.status"
              class="ml-1"
              checked="true"
              name="check-button"
              switch
              inline
            />
          </b-col>
          <b-col
            cols="12"
            class="mt-1 d-flex align-items-center"
          >
            Executivo:
            <b-form-checkbox
              v-model="template.modo_executivo"
              class="ml-1"
              checked="false"
              name="check-button"
              switch
              inline
            />
          </b-col>
        </b-row>
      </b-tab>

      <!-- Tab 2: WhatsApp Oficial -->
      <b-tab title="WhatsApp Oficial">
        <!-- Primeira Row: Configuração e Preview -->
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            <h5 class="mb-2">
              Configuração do Template
            </h5>

            <b-row>
              <b-col
                cols="12"
                class="mt-1"
              >
                Nome do Template:
                <b-form-input
                  v-model="whatsappOficial.nome"
                  placeholder="Nome do template oficial"
                />
              </b-col>

              <b-col
                cols="12"
                class="mt-1"
              >
                Idioma:
                <b-form-select
                  v-model="whatsappOficial.idioma"
                  :options="languageOptions"
                />
              </b-col>

              <b-col
                cols="12"
                class="mt-1"
              >
                Categoria:
                <b-form-select
                  v-model="whatsappOficial.categoria"
                  :options="categoryOptions"
                />
              </b-col>

              <b-col
                cols="12"
                class="mt-1"
              >
                Corpo da Mensagem:
                <b-form-textarea
                  v-model="whatsappOficial.conteudo"
                  placeholder="Digite a mensagem com variáveis: { { 1 } }, { { 2 } }, etc."
                  rows="6"
                />
              </b-col>
            </b-row>
          </b-col>

          <!-- Preview do WhatsApp -->
          <b-col
            cols="12"
            md="6"
          >
            <h5 class="mb-2">
              Preview WhatsApp
            </h5>
            <div class="whatsapp-preview">
              <div class="whatsapp-message">
                <!-- Header -->
                <div
                  v-if="previewHeader"
                  class="whatsapp-header"
                >
                  <strong>{{ previewHeader }}</strong>
                </div>

                <!-- Body -->
                <div class="whatsapp-body">
                  {{ previewBody }}
                </div>

                <!-- Footer -->
                <div
                  v-if="previewFooter"
                  class="whatsapp-footer"
                >
                  {{ previewFooter }}
                </div>

                <!-- Buttons -->
                <div
                  v-if="previewButtons.length > 0"
                  class="whatsapp-buttons"
                >
                  <div
                    v-for="(button, index) in previewButtons"
                    :key="index"
                    class="whatsapp-button"
                  >
                    <feather-icon
                      v-if="button.type === 'button_url'"
                      icon="LinkIcon"
                      size="14"
                    />
                    <feather-icon
                      v-else-if="button.type === 'button_quick_reply'"
                      icon="CornerDownRightIcon"
                      size="14"
                    />
                    <span>{{ button.default }}</span>
                    <small
                      v-if="button.type === 'button_url' && button.url"
                      class="button-url-preview"
                    >
                      ({{ button.url }})
                    </small>
                  </div>
                </div>
              </div>

              <div class="whatsapp-info">
                <small class="text-muted">
                  Template: {{ whatsappOficial.nome || 'Sem nome' }}<br>
                  Categoria: {{ whatsappOficial.categoria || 'Não definida' }}<br>
                  Idioma: {{ whatsappOficial.idioma || 'pt_BR' }}
                </small>
              </div>
            </div>
          </b-col>
        </b-row>

        <!-- Segunda Row: Parâmetros (largura total) -->
        <b-row class="mt-3">
          <b-col cols="12">
            <h5 class="mb-2">
              Parâmetros (variáveis, cabeçalho, rodapé, botões)
            </h5>
            <div class="parameters-section">
              <div
                v-for="(param, index) in whatsappOficial.parametros"
                :key="index"
                class="param-item mb-2 p-3 border rounded"
              >
                <b-row align-v="center">
                  <b-col
                    cols="12"
                    :md="param.type === 'text' ? '2' : '3'"
                  >
                    <label class="small mb-1">Tipo</label>
                    <b-form-select
                      v-model="param.type"
                      :options="parameterTypeOptions"
                      size="sm"
                    />
                  </b-col>
                  <!-- Campo Chave só aparece para tipo "text" -->
                  <b-col
                    v-if="param.type === 'text'"
                    cols="12"
                    md="2"
                  >
                    <label class="small mb-1">Chave</label>
                    <b-form-input
                      v-model="param.key"
                      placeholder="ex: { {1} }"
                      size="sm"
                    />
                  </b-col>
                  <b-col
                    cols="12"
                    :md="param.type === 'text' ? '3' : '4'"
                  >
                    <label class="small mb-1">Valor Padrão / Texto</label>
                    <b-form-input
                      v-model="param.default"
                      placeholder="Texto do botão ou valor"
                      size="sm"
                    />
                  </b-col>
                  <b-col
                    v-if="param.type === 'button_url'"
                    cols="12"
                    md="4"
                  >
                    <label class="small mb-1">URL do Botão</label>
                    <b-form-input
                      v-model="param.url"
                      placeholder="https://exemplo.com"
                      size="sm"
                    />
                  </b-col>
                  <b-col
                    cols="12"
                    :md="param.type === 'button_url' ? '1' : (param.type === 'text' ? '4' : '5')"
                    class="d-flex align-items-end"
                  >
                    <b-button
                      variant="danger"
                      size="sm"
                      class="w-100"
                      @click="removeParameter(index)"
                    >
                      <feather-icon icon="TrashIcon" />
                      Remover
                    </b-button>
                  </b-col>
                </b-row>
              </div>

              <b-button
                variant="outline-primary"
                size="sm"
                @click="addParameter"
              >
                <feather-icon icon="PlusIcon" />
                Adicionar Parâmetro
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>

    <hr>
    <b-row
      align-h="end"
      class="mt-1"
    >
      <b-col cols="auto">
        <b-button
          variant="danger"
          @click="hideAndGetModal"
        >
          Cancelar
        </b-button>
      </b-col>
      <b-col cols="auto">
        <b-button
          variant="primary"
          @click="handleSave"
        >
          {{ novoTemplate ? 'Cadastrar' : 'Salvar' }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BButton,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
  BTabs,
  BTab,
  BFormSelect,
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BTabs,
    BTab,
    BFormSelect,
    FeatherIcon,
  },
  props: {
    template: {
      type: Object,
      required: true,
    },
    novoTemplate: {
      type: Boolean,
      require: true,
    },
    // New prop to control visibility of the dialog_id input
    showDialogIdInput: {
      type: Boolean,
      default: false, // Hidden by default
    },
  },
  data() {
    return {
      activeTab: 0,
      whatsappOficial: {
        nome: '',
        idioma: 'pt_BR',
        categoria: 'UTILITY',
        status: 'ativo',
        conteudo: '',
        parametros: [],
      },
      languageOptions: [
        { value: 'pt_BR', text: 'Português (Brasil)' },
        { value: 'en_US', text: 'English (US)' },
        { value: 'es_ES', text: 'Español (España)' },
        { value: 'es_MX', text: 'Español (México)' },
      ],
      categoryOptions: [
        { value: 'MARKETING', text: 'Marketing' },
        { value: 'UTILITY', text: 'Utilitário' },
        { value: 'AUTHENTICATION', text: 'Autenticação' },
      ],
      parameterTypeOptions: [
        { value: 'text', text: 'Texto' },
        // { value: 'header', text: 'Cabeçalho' },
        // { value: 'footer', text: 'Rodapé' },
        // { value: 'button_url', text: 'Botão URL' },
        // { value: 'button_quick_reply', text: 'Botão Resposta Rápida' },
      ],
    }
  },
  computed: {
    previewBody() {
      let processedBody = this.whatsappOficial.conteudo

      this.whatsappOficial.parametros
        .filter(p => p.type === 'text' && p.key.match(/^\{\{\d+\}\}$/))
        .forEach(param => {
          const regex = new RegExp(`\\${param.key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`, 'g')
          processedBody = processedBody.replace(regex, param.default || param.key)
        })

      return processedBody
    },

    previewHeader() {
      const headerParam = this.whatsappOficial.parametros.find(p => p.type === 'header')
      return headerParam ? headerParam.default : ''
    },

    previewFooter() {
      const footerParam = this.whatsappOficial.parametros.find(p => p.type === 'footer')
      return footerParam ? footerParam.default : ''
    },

    previewButtons() {
      return this.whatsappOficial.parametros.filter(p =>
        p.type === 'button_url' || p.type === 'button_quick_reply')
    },
  },
  watch: {
    template: {
      handler() {
        this.loadTemplateData()
      },
      deep: true,
    },
    // Limpar campo 'key' quando o tipo do parâmetro mudar
    'whatsappOficial.parametros': {
      handler(newParams) {
        newParams.forEach(param => {
          // Se o tipo não for 'text', limpar o campo 'key'
          if (param.type !== 'text' && param.key) {
            param.key = ''
          }
        })
      },
      deep: true,
    },
  },
  mounted() {
    // Carregar dados do template ao editar
    this.loadTemplateData()
  },
  methods: {
    loadTemplateData() {
      // Se o template tem os campos do Meta oficial (nome, conteudo, parametros estruturados)
      if (this.template.nome && this.template.conteudo) {
        this.whatsappOficial.nome = this.template.nome || ''
        this.whatsappOficial.conteudo = this.template.conteudo || ''
        this.whatsappOficial.categoria = this.template.categoria || 'UTILITY'
        this.whatsappOficial.idioma = this.template.idioma || 'pt_BR'
        this.whatsappOficial.status = this.template.status || 'ativo'
        this.whatsappOficial.parametros = Array.isArray(this.template.parametros)
          ? this.template.parametros
          : []
      }
    },
    hideAndGetModal() {
      this.$emit('hide')
      this.$emit('templates')
      this.$emit('clear')
    },
    addParameter() {
      this.whatsappOficial.parametros.push({
        key: '',
        type: 'text',
        default: '',
        text: '',
        url: '',
      })
    },
    removeParameter(index) {
      this.whatsappOficial.parametros.splice(index, 1)
    },

    buildMetaPayload() {
      const payload = {
        name: this.whatsappOficial.nome.replace(/\s+/g, '_').toLowerCase(),
        language: this.whatsappOficial.idioma,
        category: this.whatsappOficial.categoria,
        components: [],
      }

      // Adicionar Header
      const headerParam = this.whatsappOficial.parametros.find(p => p.type === 'header')
      if (headerParam && headerParam.default) {
        payload.components.push({
          type: 'HEADER',
          format: 'TEXT',
          text: headerParam.default,
        })
      }

      // Adicionar Body
      if (this.whatsappOficial.conteudo) {
        const bodyComponent = {
          type: 'BODY',
          text: this.whatsappOficial.conteudo,
        }

        // Adicionar exemplos de variáveis
        const textParams = this.whatsappOficial.parametros
          .filter(p => p.type === 'text' && p.key.match(/^\{\{\d+\}\}$/))
          .sort((a, b) => {
            const numA = parseInt(a.key.match(/\d+/)[0])
            const numB = parseInt(b.key.match(/\d+/)[0])
            return numA - numB
          })

        if (textParams.length > 0) {
          bodyComponent.example = {
            body_text: [textParams.map(p => p.default || '')],
          }
        }

        payload.components.push(bodyComponent)
      }

      // Adicionar Footer
      const footerParam = this.whatsappOficial.parametros.find(p => p.type === 'footer')
      if (footerParam && footerParam.default) {
        payload.components.push({
          type: 'FOOTER',
          text: footerParam.default,
        })
      }

      // Adicionar Buttons
      const buttonParams = this.whatsappOficial.parametros.filter(p =>
        p.type === 'button_url' || p.type === 'button_quick_reply')

      if (buttonParams.length > 0) {
        const buttonsComponent = {
          type: 'BUTTONS',
          buttons: buttonParams.map(param => {
            const button = {
              type: param.type === 'button_url' ? 'URL' : 'QUICK_REPLY',
              text: param.text || param.default || '',
            }

            // Adicionar URL se for botão URL
            if (param.type === 'button_url' && param.url) {
              button.url = param.url
            }

            return button
          }),
        }
        payload.components.push(buttonsComponent)
      }

      return payload
    },
    handleSave() {
      if (this.activeTab === 0) {
        // Template Padrão
        if (this.validaFormulario()) {
          const templateData = {
            ...this.template,
            tipo_template: 'padrao', // Adicionar flag para identificar que é template padrão
          }
          this.novoTemplate ? this.$emit('create-template', templateData) : this.$emit('update-template', templateData)
        }
        return
      }

      // WhatsApp Oficial
      if (this.validaFormularioOficial()) {
        // Limpar o campo 'key' dos parâmetros que não são do tipo 'text'
        const parametrosLimpos = this.whatsappOficial.parametros.map(param => {
          const paramCopy = { ...param }
          // Remove 'key' se o tipo não for 'text'
          if (param.type !== 'text') {
            delete paramCopy.key
          }
          return paramCopy
        })

        const whatsappData = {
          nome: this.whatsappOficial.nome,
          categoria: this.whatsappOficial.categoria,
          idioma: this.whatsappOficial.idioma,
          status: this.whatsappOficial.status,
          conteudo: this.whatsappOficial.conteudo,
          parametros: parametrosLimpos,
          // Adicionar flag para identificar que é template oficial
          tipo_template: 'oficial',
        }
        this.novoTemplate ? this.$emit('create-template', whatsappData) : this.$emit('update-template', whatsappData)
      }
    },
    validaFormulario() {
      // Include dialogo_id in validation ONLY if it's visible
      if (this.showDialogIdInput && !this.template.dialogo_id) {
        this.$swal({
          title: 'Preencha o campo Dialog ID!',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-danger',
          },
        })
        return false
      }

      if (!(this.template.mensagem && this.template.titulo)) {
        this.$swal({
          title: 'Prencha todos campos!',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-danger',
          },
        })
        return false
      }
      return true
    },
    validaFormularioOficial() {
      if (!this.whatsappOficial.nome) {
        this.$swal({
          title: 'Preencha o nome do template!',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-danger',
          },
        })
        return false
      }

      if (!this.whatsappOficial.conteudo) {
        this.$swal({
          title: 'Preencha o corpo da mensagem!',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-danger',
          },
        })
        return false
      }

      // Validar se todos os placeholders têm default
      const placeholdersNoConteudo = (this.whatsappOficial.conteudo.match(/\{\{\d+\}\}/g) || [])
      const placeholdersComDefault = this.whatsappOficial.parametros
        .filter(p => p.type === 'text' && p.key && p.key.match(/^\{\{\d+\}\}$/))
        .map(p => p.key)

      const faltandoDefaults = placeholdersNoConteudo.filter(
        ph => !placeholdersComDefault.includes(ph),
      )

      if (faltandoDefaults.length > 0) {
        this.$swal({
          title: 'Atenção!',
          text: `Faltam valores padrão para os placeholders: ${faltandoDefaults.join(', ')}`,
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-warning',
          },
        })
        return false
      }

      // Validar campos dos parâmetros
      // eslint-disable-next-line no-restricted-syntax
      for (const param of this.whatsappOficial.parametros) {
        if (param.type === 'text' && (!param.key || !param.default)) {
          this.$swal({
            title: 'Erro nos parâmetros!',
            text: 'Parâmetros do tipo "Texto" devem ter Chave e Valor Padrão preenchidos.',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-danger',
            },
          })
          return false
        }

        if ((param.type === 'header' || param.type === 'footer' || param.type === 'button_quick_reply') && !param.default) {
          this.$swal({
            title: 'Erro nos parâmetros!',
            text: `Parâmetro do tipo "${param.type}" deve ter Valor Padrão preenchido.`,
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-danger',
            },
          })
          return false
        }

        if (param.type === 'button_url') {
          if (!param.default) {
            this.$swal({
              title: 'Erro no botão URL!',
              text: 'Botões URL devem ter um texto definido.',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-danger',
              },
            })
            return false
          }

          if (!param.url || !param.url.match(/^https?:\/\/.+/)) {
            this.$swal({
              title: 'URL inválida!',
              text: 'Botões URL devem ter uma URL válida começando com http:// ou https://',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-danger',
              },
            })
            return false
          }
        }
      }

      return true
    },
  },
}
</script>

<style lang="scss" scoped>
.whatsapp-preview {
  background: #e5ddd5;
  border-radius: 10px;
  padding: 20px;
  min-height: 320px;
}

.whatsapp-message {
  background: white;
  border-radius: 7.5px;
  padding: 10px;
  box-shadow: 0 1px 0.5px rgba(0, 0, 0, 0.13);
  margin-bottom: 15px;
  position: relative;
}

.whatsapp-message::before {
  content: '';
  position: absolute;
  top: 0;
  right: -8px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 0 10px 10px;
  border-color: transparent transparent white transparent;
}

.whatsapp-header {
  font-size: 16px;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
  color: #000;
}

.whatsapp-body {
  font-size: 14px;
  line-height: 1.5;
  color: #303030;
  white-space: pre-wrap;
  word-wrap: break-word;
  margin-bottom: 8px;
}

.whatsapp-footer {
  font-size: 12px;
  color: #8696a0;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #e0e0e0;
}

.whatsapp-buttons {
  margin-top: 10px;
  border-top: 1px solid #e0e0e0;
  padding-top: 10px;
}

.whatsapp-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  margin: 5px 0;
  background: #fff;
  border: 1px solid #d1d7db;
  border-radius: 5px;
  color: #00a5f4;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  flex-wrap: wrap;

  svg {
    margin-right: 5px;
  }

  .button-url-preview {
    display: block;
    width: 100%;
    font-size: 10px;
    color: #8696a0;
    margin-top: 4px;
    text-align: center;
  }

  &:hover {
    background: #f5f6f6;
  }
}

.whatsapp-info {
  margin-top: 15px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 5px;
}

.parameters-section {
  .param-item {
    background: #f8f9fa;
    transition: all 0.3s ease;

    &:hover {
      background: #e9ecef;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    label {
      font-weight: 600;
      color: #495057;
      margin-bottom: 0.25rem;
    }
  }
}
</style>
